/**
 * @desc 参数列表查询
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.ParamListRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.ParamListResponse>>> {
  return defHttp.post({
    url: '/wap/ParamManage/qryParamList',
    data,
  });
}

export function mock(
  data: defs.ParamListRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.ParamListResponse>>> {
  return defHttp.post({
    url: '/mock/wap/ParamManage/qryParamList',
    data,
  });
}
